import React from 'react'
import Axios from 'axios'
import More from './images/more.png'
import Search from './images/search.png'
import UploadImg from './images/uploadImg.png'
import Folder from './images/folder.png'
import HistoryRecord from './images/historyRecord.png'
import Editor from 'wangeditor'
import "./ChatContent.css"

export default class ChatContent extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            moreState: false,
            showHistory: false,
            recordMessageData: [],   // 群聊 聊天记录
            ownMessageData: [],       // 私聊 聊天记录
            groupMemberInfo: [],   // 获取群组中的信息, 写在了325行
            groupChatMessage: [],
            editorContent: "",
            friendItemInfo: {},   // 当前好友详细信息
            uploadFileName: "",   // 上传文件名
        }
        this.imgInput = React.createRef()
        this.fileInput = React.createRef()
        this.editor = new Editor("#toolbar-container", "#text-container")
    }

    // 初始化编辑器
    componentDidMount() {
        
        // 自定义菜单配置
        this.editor.customConfig.menus = [
            'image',  // 插入图片
        ];
        // 使用 base64 格式保存图片.即可选择本地图片,编辑器用 base64 格式显示图片.
        this.editor.customConfig.uploadImgShowBase64 = true

        this.editor.customConfig.onchange = () => {

            this.setState({
                editorContent: this.editor.txt.text()
            })
        }

        this.editor.create()

        const apiRoot = global.url.im;
        let data = {
            "current": 1,
            "size": 10,
            "orders": [
                { "column": "create_time", "asc": false }
            ]
        }

        // 获取群组为showMessageId的群组成员信息
        Axios.get(`${apiRoot}/group/${this.props.showMessageId}/member/info`)
            .then(res => {
                this.setState({
                    groupMemberInfo: res.data.payload
                })
            })
    }


    // 删除好友
    deleteFriendItem = (id) => {
        const apiRoot = global.url.im;
        id = parseInt(id)
        console.log("删除好友id: " + id)
        Axios.delete(`${apiRoot}/friend/del?user1=${this.props.onlineUserId}&user2=${id}`)
            .then(res => {
                console.log(res.message)
                window.location.reload()
            })
    }


    // 上传图片
    handleImgChange = (event) => {

        const { contactType, onlineUserId, showMessageId, messageData } = this.props
        event.preventDefault();

        let data = new FormData()
        data.append("file", this.imgInput.current.files[0])

        console.log(this.imgInput.current.files[0], "---- 图片正在上传中...")

        // 上传文件到指定服务器
        Axios.post(`${global.support.ossUpload}/oss/upload`, data, {
            headers: {
                "Content-Type": "multipart/form-data;"
            }
        }).then(res => {
console.log(res)
            if (res.status === 200) {

                if (contactType === "public") {
                    // 上传成功后将返回值更新列表
                    this.props.client.publish(`/group/${showMessageId}`, res.data.payload, "img")

                    // 更新侧边栏位置
                    messageData.some((item) => {
                        if (item.receiverId === showMessageId) {
                            let temp = item
                            temp.lastMessage = "[图片]"
                            messageData.splice(messageData.indexOf(item), 1)
                            messageData.unshift(temp)
                            return true
                        }
                    })

                    this.setState({
                        messageData: this.state.messageData
                    })

                    // 自己更新聊天信息框
                    let tmpMessage = {
                        "messageType": contactType,
                        "contentType": "img",
                        "senderId": onlineUserId,
                        "receiverId": showMessageId,
                        "content": res.data.payload
                    }

                    this.props.updateChatMessageInfo(tmpMessage, contactType)
                } else if (contactType === "private") {
                    // 上传成功后将返回值更新列表
                    this.props.client.send(showMessageId, res.data.payload, "img")

                    // 更新侧边栏位置
                    messageData.some((item) => {
                        if (item.receiverId === showMessageId) {
                            let temp = item
                            temp.lastMessage = "[图片]"
                            messageData.splice(messageData.indexOf(item), 1)
                            messageData.unshift(temp)
                            return true
                        }
                    })

                    this.setState({
                        messageData: this.state.messageData
                    })

                    // 自己更新聊天信息框
                    let tmpMessage = {
                        "messageType": contactType,
                        "contentType": "img",
                        "senderId": onlineUserId,
                        "receiverId": showMessageId,
                        "content": res.data.payload
                    }

                    this.props.updateChatMessageInfo(tmpMessage, contactType)
                }

            }
        })
    }


    // 上传文件
    handlefileChange = (event) => {
        const { contactType, onlineUserId, showMessageId, messageData } = this.props
        event.preventDefault();

        let data = new FormData()
        data.append("file", this.fileInput.current.files[0])

        console.log(this.fileInput.current.files[0], "---- 文件正在上传中...")


        // 上传文件到指定服务器
        Axios.post(`${global.support.ossUpload}/oss/upload`, data, {
            headers: {
                "Content-Type": "multipart/form-data;"
            }
        }).then(res => {

            if (contactType === "public") {
                // 上传成功后将返回值更新列表
                this.props.client.publish(`/group/${showMessageId}`, res.data.payload, "file")

                // 更新侧边栏位置
                messageData.some((item) => {
                    if (item.receiverId === showMessageId) {
                        let temp = item
                        temp.lastMessage = "[文件]"
                        messageData.splice(messageData.indexOf(item), 1)
                        messageData.unshift(temp)
                        return true
                    }
                })

                this.setState({
                    messageData: this.state.messageData,
                    
                })

                // 自己更新聊天信息框
                let tmpMessage = {
                    "messageType": contactType,
                    "contentType": "file",
                    "senderId": onlineUserId,
                    "receiverId": showMessageId,
                    "content": res.data.payload
                }

                this.props.updateChatMessageInfo(tmpMessage, contactType)
            } else if (contactType === "private") {
                // 上传成功后将返回值更新列表
                this.props.client.send(showMessageId, res.data.payload, "file")

                // 更新侧边栏位置
                messageData.some((item) => {
                    if (item.receiverId === showMessageId) {
                        let temp = item
                        temp.lastMessage = "[文件]"
                        messageData.splice(messageData.indexOf(item), 1)
                        messageData.unshift(temp)
                        return true
                    }
                })

                this.setState({
                    messageData: this.state.messageData,
                    
                })

                // 自己更新聊天信息框
                let tmpMessage = {
                    "messageType": contactType,
                    "contentType": "file",
                    "senderId": onlineUserId,
                    "receiverId": showMessageId,
                    "content": res.data.payload
                }

                this.props.updateChatMessageInfo(tmpMessage, contactType)
               
            }
        })
    }



    // 显示聊天记录 当前页码 群聊
    handleShowHistory = (page) => {
        const apiRoot = global.url.im
        let data = {
            "current": page,
            "size": 10,
            "orders": [
                { "column": "create_time", "asc": false }
            ]
        }

        this.setState({
            showHistory: true
        }, () => {
            Axios.post(`${apiRoot}/message/public/page?groupId=${this.props.showMessageId}`, data)
                .then(res => {
                    this.setState({
                        recordMessageData: res.data.records
                    })
                })
        })
    }

    // 发送消息
    sendMessage = () => {
        const { editorContent } = this.state
        const { contactType, showMessageId, onlineUserId } = this.props

        if (contactType === "public") {
            // 发送公聊消息 - 纯文本
            const { messageData } = this.props
            this.props.client.publish(`/group/${showMessageId}`, editorContent)

            let tmpMessage = {
                "messageType": "public",
                "contentType": "text",
                "senderId": onlineUserId,
                "receiverId": showMessageId,
                "content": editorContent
            }

            // 更新侧边栏位置
            messageData.some((item) => {
                if (item.receiverId === showMessageId) {
                    let temp = item
                    temp.lastMessage = editorContent
                    messageData.splice(messageData.indexOf(item), 1)
                    messageData.unshift(temp)
                    return true
                }
            })

            this.setState({
                messageData: messageData,
                editorContent: this.editor.txt.text(""),
            })

            // 自己更新聊天信息框
            this.props.updateChatMessageInfo(tmpMessage, contactType)


        } else if (contactType === "private") {
            const { messageData } = this.props
            // 发送私聊消息 - 纯文本
            this.props.client.send(showMessageId, editorContent)

            let tmpMessage = {
                "messageType": "private",
                "contentType": "text",
                "senderId": onlineUserId,
                "receiverId": showMessageId,
                "content": editorContent
            }

            // 更新侧边栏位置
            messageData.some((item) => {
                if (item.receiverId === showMessageId) {
                    let temp = item
                    temp.lastMessage = editorContent
                    messageData.splice(messageData.indexOf(item), 1)
                    messageData.unshift(temp)
                    return true
                }
            })

            this.setState({
                messageData: messageData,
                editorContent: this.editor.txt.text("")
            })

            this.props.updateChatMessageInfo(tmpMessage, contactType)
        }

    }

    // 格式化时间
    formatTime = (time) => {
        let formatTime = new Date(Date.parse(time))
        return `${formatTime.getHours()}:${formatTime.getMinutes()}`

    }


    // 处理获取好友详细信息
    handleGetFriendInfo = () => {
        const { onlineUserId, showMessageId } = this.props
        const apiRoot = global.url.im;

        // 获取showMessageId的好友信息
        Axios.get(`${apiRoot}/friend/${onlineUserId}`)
            .then(res => {
                const data = res.data.payload
                data.some((item) => {
                    if (item.toUserId === showMessageId) {
                        new Promise((resolve) => {

                            this.setState({
                                friendItemInfo: item
                            })
                            let inter = setInterval(() => {
                                if (this.state.friendItemInfo.friendInfo) {
                                    clearInterval(inter)
                                    resolve()
                                }
                            }, 100)
                        }).then(() => {
                            this.setState({
                                moreState: true
                            })
                        })
                    }
                })

            })
    }

    render() {
        const { moreState, showHistory, recordMessageData, groupMemberInfo, friendItemInfo } = this.state
        const { messageItem, chatmessageInfo, onlineUserId, contactType, showMessageId } = this.props

        // 我的消息列表(分成公聊和私聊)
        if (contactType === "public") {
            return <div style={{ display: "flex", flexDirection: "column", overflow: "hidden" }}>
                <div style={{ height: "48px", background: "#fff", display: "flex", justifyContent: "space-between", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div style={{ marginLeft: "40px", color: "#000000a5", fontSize: "16px", maxWidth: "500px", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                        {messageItem.contactName}
                    </div>
                    <div
                        style={{ marginRight: "16px", background: `url(${More})`, width: "48px", height: "48px", cursor: "pointer", position: "relative" }}
                        tabIndex="-1"
                        onFocus={() => {
                            const apiRoot = global.url.im;
                            // 获取群组为showMessageId的群组成员信息
                            Axios.get(`${apiRoot}/group/${showMessageId}/member/info`)
                                .then(res => {
                                    this.setState({
                                        moreState: true,
                                        groupMemberInfo: res.data.payload
                                    })
                                })

                        }}
                        onBlur={(e) => {
                            // debugger
                            if (!e.currentTarget.contains(e.relatedTarget)) {
                                this.setState({
                                    moreState: false
                                })
                            }
                        }}
                    >
                        {
                            moreState && <div
                                style={{ zIndex: 2, position: "absolute", top: "48px", left: "-192px", width: "240px", height: "625px", boxShadow: "0 3px 6px 0 #00000029", background: "#f5f7fa", display: "flex", flexDirection: "column" }}
                            >
                                <div style={{ width: "240px", height: "40px", background: "#fff", color: "#000000a5", fontSize: "14px", padding: "10px 20px" }}>
                                    群组名称
                                    </div>
                                <div style={{ width: "240px", height: "40px", background: "#f5f7fa", fontSize: "14px", color: "#00000072", padding: "10px 20px", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                                    {messageItem.contactName}
                                </div>
                                <div style={{ width: "240px", height: "40px", background: "#fff", color: "#000000a5", fontSize: "14px", padding: "10px 20px" }}>
                                    群成员
                                        </div>
                                <div style={{ width: "240px", height: "52px", background: "#f5f7fa", fontSize: "14px", color: "#00000072", padding: "10px 20px", }}>
                                    <div style={{ width: "200px", height: "32px", border: "1px solid #d3d3d3", display: "flex", alignItems: "center" }}>
                                        <div style={{ background: `url(${Search})`, width: "20px", height: "20px", marginLeft: "10px" }}>

                                        </div>
                                        <div style={{ width: "160px", height: "20px", marginLeft: "10px", }}>
                                            <input
                                                onFocus={() => {
                                                    this.setState({
                                                        moreState: true
                                                    })
                                                }}
                                                onBlur={() => {
                                                    this.setState({
                                                        moreState: false
                                                    })
                                                }}
                                                style={{ width: "160px", height: "20px", outline: "none", border: "none", background: "#f5f7fa" }}
                                                placeholder="查找成员"
                                                onKeyUp={(e) => {
                                                    if (e.keyCode === 13) {
                                                        alert("正在搜索:" + e.target.value)
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: "240px", height: "27px", background: "#fff", fontSize: "14px", padding: "0 20px" }}>
                                    <div style={{ width: "200px", height: "27px", borderBottom: "1px solid #d3d3d3", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                        <div style={{ fontSize: "14px", color: "#00000072" }}>
                                            {`共${groupMemberInfo && groupMemberInfo.length}人`}
                                        </div>
                                        <div style={{ fontSize: "12px", color: "#0072e5" }}>
                                            添加成员
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: "240px", height: "425px", overflow: "auto", marginTop: "10px" }}>
                                    {
                                        groupMemberInfo.map((item, index) => {

                                            return (
                                                <div style={{ width: "240px", height: "40px", display: "flex", alignItems: "center", padding: "0 20px" }} key={`group-friends-${index}`}>
                                                    <div style={{ width: "36px", height: "36px", background: `url(${item.account && item.account.avatar})`, backgroundSize: "cover" }}>

                                                    </div>
                                                    <div style={{ marginLeft: "16px", fontSize: "16px", color: "#8c8c8c" }}>
                                                        {item.account && item.account.userName}
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </div>
                {/* 当前聊天信息 */}

                <div style={{ width: "100%", height: "617px", margin: "8px 0", background: "#f5f7fa", overflow: "auto" }}
        
                >
                    {
                        chatmessageInfo && chatmessageInfo.map((item) => {

                            let itemRightAvatar, itemLeftAvatar
                            groupMemberInfo.some((member) => {
                                if (member.userId === item.senderId) {
                                    if (item.senderId === onlineUserId) {
                                        itemRightAvatar = member.account.avatar
                                        itemLeftAvatar = undefined
                                        return true
                                    } else {
                                        itemLeftAvatar = member.account.avatar
                                        itemRightAvatar = undefined
                                        return true
                                    }

                                }

                            })
                            const itemClassTop = item.senderId !== onlineUserId ? "my-messageTop-item" : "other-messageTop-item"
                            const itemClass = item.senderId !== onlineUserId ? "my-message-item" : "other-message-item"
                            return (
                                <div style={{ display: "flex", width: "100%", minHeight: "75px" }} key={`chat-message-${item.serial}`}>
                                    <div style={{ width: "112px", minHeight: "75px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <div style={{ width: "48px", height: "48px", background: `url(${itemLeftAvatar}) 0 0 / cover` }}>

                                        </div>
                                    </div>

                                    <div style={{ flex: "1 1 0" }}>
                                        <div className={itemClassTop} style={{ width: "100%", display: "flex" }}>
                                            <div className={itemClass}>
                                                {item.contentType === 'text' && <div dangerouslySetInnerHTML={{ __html: item.content }} />}
                                                {item.contentType === 'img' && <img src={`${global.support.ossUpload}${item.content}`} style={{ width: "160px" }} />}
                                                {item.contentType === 'file' && <a href={item.content}>文件</a>}

                                            </div>
                                        </div>
                                    </div>

                                    <div style={{ width: "112px", height: "75px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <div style={{ width: "48px", height: "48px", background: `url(${itemRightAvatar}) 0 0 / cover` }}>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                <div style={{ width: "100%", height: "208px", background: "#fff", display: "flex", flexDirection: "column" }}>
                    <div style={{ width: "100%", height: "40px", display: "flex", alignItems: "center" }}>
                        <div style={{ width: "32px", height: "32px", background: `url(${UploadImg})`, marginLeft: "40px", marginRight: "8px" }}>
                            <input
                                type="file"
                                name="imgfile"
                                ref={this.imgInput}
                                style={{ opacity: "0", width: "32px", height: "32px", overflow: "hidden" }}
                                onChange={this.handleImgChange}
                                accept="image/gif,image/jpeg,image/jpg,image/png,image/svg"
                            />
                        </div>

                        <div style={{ width: "32px", height: "32px", background: `url(${Folder})`, marginRight: "8px", cursor: "pointer" }}>
                            <input
                                type="file"
                                name="file"
                                ref={this.fileInput}
                                style={{ opacity: "0", width: "32px", height: "32px", overflow: "hidden" }}
                                onChange={this.handlefileChange}
                            />
                        </div>

                        <div style={{ width: "32px", height: "32px", background: `url(${HistoryRecord})`, marginRight: "8px" }}
                            onClick={() => { this.handleShowHistory(1) }}
                        >
                            {
                                showHistory && <div
                                    style={{ background: "#fff", position: "absolute", top: "50%", left: "50%", margin: "-276px 0 0 -217px", width: "435px", height: "552px", boxShadow: "0 3px 6px 0 #00000029", display: "flex", flexDirection: "column" }}
                                >
                                    <div style={{ width: "435px", height: "65px", textAlign: "center", background: "#fff" }}>
                                        <div style={{ margin: "16px 36px", width: "363px", height: "32px", border: "1px solid #d3d3d3", borderRadius: "4px", background: "#f5f7fa", display: "flex", alignItems: "center" }}>
                                            <div style={{ width: "20px", height: "20px", background: `url(${Search})`, marginLeft: "10px" }}>
                                            </div>
                                            <div style={{ width: "300px", height: "20px", marginLeft: "10px" }}>
                                                <input
                                                    style={{ width: "300px", height: "20px", outline: "none", background: "#f5f7fa", border: "none" }}
                                                    placeholder="查找记录"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div style={{ width: "435px", height: "438px", padding: "0 16px" }}>
                                        <div style={{ width: "403px", height: "438px", borderTop: "1px solid #d3d3d3", borderBottom: "1px solid #d3d3d3", overflow: "auto" }}>
                                            {
                                                recordMessageData.map((item, index) => {

                                                    let itemAvatar, itemName
                                                    groupMemberInfo.some((member) => {
                                                        if (member.userId === item.senderId) {
                                                            itemAvatar = member.account.avatar
                                                            itemName = member.account.userName
                                                            return true
                                                        }
                                                    })
                                                    if (item.contentType && item.contentType === "text") {
                                                        return (
                                                            <div style={{ width: "390px", height: "76px", display: "flex" }} key={`group-record-${index}`}>
                                                                <div style={{ width: "50px", height: "76px", padding: "15px 0 0 16px" }}>
                                                                    <input type="radio" style={{ width: "18px", height: "18px" }} />
                                                                </div>
                                                                <div style={{ width: "314px", height: "76px", display: "flex" }}>
                                                                    <div style={{ marginTop: "6px", width: "36px", height: "36px", background: `url(${itemAvatar && itemAvatar})`, backgroundSize: "cover" }}>

                                                                    </div>
                                                                    <div style={{ marginLeft: "12px", width: "266px", height: "76px", display: "flex", flexDirection: "column" }}>
                                                                        <div style={{ width: "266px", height: "30px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                                            <div style={{ maxWidth: "120px", fontSize: "12px", color: "#393939", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                                                                                {itemName}
                                                                            </div>
                                                                            <div style={{ maxWidth: "80px", fontSize: "12px", color: "#393939", }}>
                                                                                {this.formatTime(item.createTime)}
                                                                            </div>
                                                                        </div>

                                                                        <div className="record-message-item" style={{ width: "266px", height: "38px", color: "#969696", fontSize: "14px", lineHeight: "1.5" }}>
                                                                            {item.content}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                })
                                            }

                                        </div>
                                    </div>

                                    <div style={{ width: "435px", height: "48px", display: "flex" }}>
                                        <div style={{ width: "218px", height: "48px", display: "flex", alignItems: "center" }}>
                                            <div style={{ width: "142px", height: "18px", marginLeft: "32px", display: "flex" }}>
                                                <div>
                                                    <input id="selct-record" type="checkbox" style={{ width: "18px", height: "18px" }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="selct-record" style={{ marginLeft: "16px", width: "28px", fontSize: "14px", color: "#00000072" }}>全选</label>
                                                </div>
                                                <div
                                                    style={{ marginLeft: "48px", width: "28px", height: "18px", lineHeight: "18px", fontSize: "14px", color: "#00000072", cursor: "pointer" }}
                                                    onClick={e => {
                                                        e.stopPropagation();
                                                        this.setState({
                                                            showHistory: false
                                                        })
                                                    }}
                                                >
                                                    取消
                                                    </div>
                                            </div>

                                        </div>
                                        <div
                                            style={{ width: "217px", height: "48px", display: "flex", justifyContent: "center", alignItems: "center", fontSize: "14px", color: "#0072e5" }}
                                        >
                                            导出记录
                                            </div>
                                    </div>

                                </div>
                            }
                        </div>
                    </div>
                    <div id="text-container" style={{ maxWidth: "1143px", height: "120px", overflow: "auto" }}>

                    </div>
                    <div style={{ width: "100%", height: "48px", display: "flex", alignItems: "center", flexDirection: "row-reverse" }}>
                        <div
                            style={{
                                width: "80px", height: "32px", lineHeight: "32px", textAlign: "center", borderRadius: "6px", background: "#0072e5", color: "#fff", marginRight: "88px", cursor: "pointer"
                            }}
                            onClick={this.sendMessage}
                        >
                            发送
                        </div>
                    </div>
                </div>
            </div>

        } else if (contactType === "private") {
            return <div style={{ display: "flex", flexDirection: "column", overflow: "hidden" }}>
                <div style={{ height: "48px", background: "#fff", display: "flex", justifyContent: "space-between", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div style={{ marginLeft: "40px", color: "#000000a5", fontSize: "16px", maxWidth: "500px", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                        {messageItem.contactName}
                    </div>
                    <div
                        style={{ marginRight: "16px", background: `url(${More})`, width: "48px", height: "48px", cursor: "pointer", position: "relative" }}
                        tabIndex="-1"
                        onFocus={this.handleGetFriendInfo}
                        onBlur={(e) => {
                            if (!e.currentTarget.contains(e.relatedTarget)) {
                                this.setState({
                                    moreState: false
                                })
                            }
                        }}
                    >
                        {
                            moreState && <div
                                style={{
                                    zIndex: 2, position: "absolute", top: "48px", left: "-192px", width: "240px", height: "229px", boxShadow: "0 3px 6px 0 #00000029",
                                    display: "flex", flexDirection: "column", background: "#fff", display: "flex", flexDirection: "column"
                                }}
                            >
                                <div style={{ width: "240px", height: "88px", padding: "24px 20px 40px 20px", display: "flex", alignItems: "center" }}>
                                    <div style={{ width: "36px", height: "36px", background: `url(${friendItemInfo.friendInfo && friendItemInfo.friendInfo.avatar})`, backgroundSize: "cover" }}>

                                    </div>
                                    <div style={{ width: "170px", height: "21px", marginLeft: "16px", fontSize: "16px", color: "#8c8c8c" }}>
                                        {friendItemInfo.friendInfo && friendItemInfo.friendInfo.userName}
                                    </div>
                                </div>

                                <div style={{
                                    width: "240px", height: "101px", padding: "0 20px",
                                    display: "flex", flexDirection: "column", color: "#8c8c8c"
                                }}>
                                    <div style={{ maxWidth: "200px", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                                        {`备注：${friendItemInfo.memoName}`}
                                    </div>
                                    <div style={{ maxWidth: "200px", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                                        {`账号：${friendItemInfo.friendInfo && friendItemInfo.friendInfo.phone}`}
                                    </div>
                                </div>

                                <div
                                    style={{ width: "240px", height: "40px", lineHeight: "40px", textAlign: "center", color: "#8c8c8c", fontSize: "13px", border: "none" }}
                                    onClick={() => { this.deleteFriendItem(messageItem.friendInfo && messageItem.friendInfo.userId) }}
                                >
                                    删除好友
                                </div>
                            </div>
                        }
                    </div>
                </div>
                {/*聊天记录 */}
                <div style={{ width: "100%", height: "617px", margin: "8px 0", background: "#f5f7fa", overflow: "auto" }}
            
                >
                    {
                        chatmessageInfo && chatmessageInfo.map((item) => {

                            let itemRightAvatar, itemLeftAvatar
                            groupMemberInfo.some((member) => {
                                if (member.userId === item.senderId) {
                                    if (item.senderId === onlineUserId) {
                                        itemRightAvatar = member.account.avatar
                                        itemLeftAvatar = undefined
                                        return true
                                    } else {
                                        itemLeftAvatar = member.account.avatar
                                        itemRightAvatar = undefined
                                        return true
                                    }
                                }

                            })
                            const itemClassTop = item.senderId !== onlineUserId ? "my-messageTop-item" : "other-messageTop-item"
                            const itemClass = item.senderId !== onlineUserId ? "my-message-item" : "other-message-item"
                            return (
                                <div style={{ display: "flex", width: "100%", minHeight: "75px" }} key={`chat-message-${item.serial}`}>
                                    <div style={{ width: "112px", minHeight: "75px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <div style={{ width: "48px", height: "48px", background: `url(${itemLeftAvatar}) 0 0 / cover` }}>

                                        </div>
                                    </div>

                                    <div style={{ flex: "1 1 0" }}>
                                        <div className={itemClassTop} style={{ width: "100%", display: "flex" }}>
                                            <div className={itemClass}>
                                                {item.contentType === 'text' && <div dangerouslySetInnerHTML={{ __html: item.content }} />}
                                                {item.contentType === 'img' && <img src={`${global.support.ossUpload}${item.content}`} style={{ width: "160px" }} />}
                                                {item.contentType === 'file' && <a href={`${global.support.ossUpload}${item.content}`}>文件</a>}
                                            </div>
                                        </div>
                                    </div>

                                    <div style={{ width: "112px", height: "75px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <div style={{ width: "48px", height: "48px", background: `url(${itemRightAvatar}) 0 0 / cover`}}>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                <div style={{ width: "100%", height: "208px", background: "#fff", display: "flex", flexDirection: "column" }}>
                    <div style={{ width: "100%", height: "40px", display: "flex", alignItems: "center" }}>
                        <div style={{ width: "32px", height: "32px", background: `url(${UploadImg})`, marginLeft: "40px", marginRight: "8px" }}>
                            <input
                                type="file"
                                name="imgfile"
                                ref={this.imgInput}
                                style={{ opacity: "0", width: "32px", height: "32px", overflow: "hidden" }}
                                onChange={this.handleImgChange}
                                accept="image/gif,image/jpeg,image/jpg,image/png,image/svg"
                            />
                        </div>

                        <div style={{ width: "32px", height: "32px", background: `url(${Folder})`, marginRight: "8px", cursor: "pointer" }}>
                            <input
                                type="file"
                                name="file"
                                ref={this.fileInput}
                                style={{ opacity: "0", width: "32px", height: "32px", overflow: "hidden" }}
                                onChange={this.handlefileChange}
                            />
                        </div>
                        <div
                            style={{ width: "32px", height: "32px", background: `url(${HistoryRecord})`, marginRight: "8px" }}
                        // onClick={this.handleShowHistory}
                        >
                        </div>
                    </div>
                    <div id="text-container" style={{ maxWidth: "1143px", height: "120px", overflow: "auto" }}>

                    </div>
                    <div style={{ width: "100%", height: "48px", display: "flex", alignItems: "center", flexDirection: "row-reverse" }}>
                        <div
                            style={{
                                width: "80px", height: "32px", lineHeight: "32px", textAlign: "center", borderRadius: "6px", background: "#0072e5", color: "#fff", marginRight: "88px", cursor: "pointer"
                            }}
                            onClick={this.sendMessage}
                        >
                            发送
                        </div>
                    </div>
                </div>
            </div>
        } else {
            return null
        }
    }
}